<template>
  <div
    class="tooltip-wrapper"
    ref="wrapperRef"
    @mouseenter="showTooltip"
    @mouseleave="hideTooltip"
    @touchstart="toggleTooltip"
  >
    <slot></slot>
    <Teleport to="#tooltip-root">
      <div v-if="visible" class="tooltip" :style="tooltipStyle">
        <img src="../assets/img/premium-icon.svg" alt="" />
        <p class="gradient-text">{{ text }}</p>
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted, onUnmounted } from 'vue'

defineProps({
  text: String
})

const visible = ref(false)
const wrapperRef = ref(null)
const tooltipStyle = ref({})

const updatePosition = () => {
  if (!wrapperRef.value) return
  const rect = wrapperRef.value.getBoundingClientRect()
  tooltipStyle.value = {
    left: `${rect.left + rect.width / 2}px`,
    top: `${rect.top - 8}px`
  }
}

const showTooltip = () => {
  updatePosition()
  visible.value = true
}

const hideTooltip = () => {
  visible.value = false
}

const toggleTooltip = event => {
  event.stopPropagation()
  if (!visible.value) updatePosition()
  visible.value = !visible.value
}

const handleClickOutside = event => {
  if (!event.target.closest('.tooltip-wrapper')) {
    hideTooltip()
  }
}

onMounted(() => {
  document.addEventListener('touchstart', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('touchstart', handleClickOutside)
})
</script>

<style scoped>
.tooltip-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip {
  position: fixed;
  transform: translate(-50%, -100%);
  background-color: #292c2c;
  color: #fff;
  text-align: center;
  padding: 7px 10px;
  border-radius: 5px;
  white-space: nowrap;
  align-items: center;
  gap: 5px;
  width: max-content;
  pointer-events: none;

  display: flex;
}

.tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #292c2c transparent transparent transparent;
}

.tooltip img {
  width: 1rem;
}

.tooltip p {
  font-weight: normal;
  font-family: 'figtree-regular';
  font-size: 14px;
}
</style>
